import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localStore from 'store'
import en from './en.json' // English
import fr from './fr.json' // French
import nl from './nl.json' // Dutch
import pt from './pt.json' // Portuguese
import es from './es.json' // Spanish
import de from './de.json' // German

Vue.use(VueI18n)

const messages = {
  en,
  fr,
  nl,
  pt,
  es,
  de
}

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

const numberFormats = {
  gbp: {
    currency: {
      style: 'currency', currency: 'GBP', currencyDisplay: 'symbol'
    }
  },
  eur: {
    currency: {
      style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'
    }
  },
  usd: {
    currency: {
      style: 'currency', currency: 'USD', currencyDisplay: 'symbol'
    }
  }
}

const getLocale = () => {
  if (localStore.get('language')) return localStore.get('language')

  const languages = Object.keys(messages)
  let useNavigatorLanguage = false

  for (let i = 0; i < languages.length; i++) { // eslint-disable-line no-plusplus
    if (languages[i] === navigator.language) useNavigatorLanguage = true
  }

  if (useNavigatorLanguage) return navigator.language

  return 'en'
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'en',
  dateTimeFormats,
  numberFormats,
  messages
})

export function t (...args) {
  return i18n.t(...args)
}

export function tc (...args) {
  return i18n.tc(...args)
}

export function te (...args) {
  return i18n.te(...args)
}

export function d (...args) {
  return i18n.d(...args)
}

export function n (...args) {
  return i18n.n(...args)
}

export default i18n
